'use memo';

import { DocumentTypes, type UploadedDocument } from '@urbanx/agx-ui-components';
import SearchNow from '../SearchNow/SearchNow';
import AttachAsFile from '../AttachAsFile/AttachAsFile';
import { useAppSelector } from 'hooks/useAppSelector';
import {
  ComparativeMarketAnalysis as ComparativeMarketAnalysisComponent,
  type ComparativeMarketAnalysisProps,
} from '@urbanx/agx.ui-components2';

type AgentComparativeMarketAnalysisProps = Omit<
  ComparativeMarketAnalysisProps<UploadedDocument>,
  'renderSearchNow' | 'renderAttachAsFile'
>;

const ComparativeMarketAnalysis = ({
  id,
  onValueChanged,
  defaultValue,
  validate,
}: AgentComparativeMarketAnalysisProps) => {
  const searchNowEnabled = useAppSelector((state) => state.cmaPropertySearch.searchNowEnabled);

  return (
    <ComparativeMarketAnalysisComponent
      id={id}
      onValueChanged={onValueChanged}
      defaultValue={defaultValue}
      validate={validate}
      allowSearch={searchNowEnabled !== false}
      renderSearchNow={(props) => <SearchNow key={props.id} {...props} />}
      renderAttachAsFile={(props) => (
        <AttachAsFile
          key={props.id}
          {...props}
          documentType={DocumentTypes.ComparativeMarketAnalysis}
        />
      )}
    />
  );
};

export default ComparativeMarketAnalysis;
